import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4z"
}), 'ClassSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ClassSharp.js
// module id = 2806
// module chunks = 2